// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentIsValidMemberNumberModelResponse {
    static getAttributeTypeMap() {
        return EnrollmentIsValidMemberNumberModelResponse.attributeTypeMap;
    }
}
EnrollmentIsValidMemberNumberModelResponse.discriminator = undefined;
EnrollmentIsValidMemberNumberModelResponse.additionalProperties = false;
EnrollmentIsValidMemberNumberModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EnrollmentIsValidMemberNumberModel"
    },
];
//# sourceMappingURL=enrollmentIsValidMemberNumberModelResponse.js.map